import { MeshMaterial } from '@pixi/mesh';

MeshMaterial.prototype._renderCanvas = function _renderCanvas(renderer, mesh) {
  renderer.plugins.mesh.render(mesh);
};
//# sourceMappingURL=MeshMaterial.mjs.map
